import { useEffect, useRef, useState } from 'react';

export function useAgentTelemetry(sessionId: string) {
    const [evt, setEvt] = useState<any>(null);
    const raf = useRef<number | null>(null);

    useEffect(() => {
        const es = new EventSource(`/api/agent/${sessionId}/telemetry`);
        let last: any = null;

        es.onmessage = e => {
            last = JSON.parse(e.data);
            if (!raf.current) {
                raf.current = requestAnimationFrame(() => {
                    setEvt(last);
                    if (raf.current) cancelAnimationFrame(raf.current);
                    raf.current = null;
                });
            }
        };

        return () => {
            es.close();
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [sessionId]);

    return evt;
}
